import service from '../service'
import store from '../../store'

export default {
// 列表
  queryPage(params) {
    return service.post('/whale-pc/role/queryRolePage', params)
  },
  detail(params) {
    return service.post('/whale-pc/role/detail', params)
  },
  listMenuTreeVO(params) {
    return service.post('/whale-pc/menu/listMenuTreeVO', params)
  },
  addOrUpdateRoleOperation(params) {
    return service.post('/whale-pc/role/addOrUpdateRoleOperation', params)
  },
  delRole(params) {
    return service.post('/whale-pc/role//del', params)
  },
  listMenuVO(params) {
    return service.post('/whale-pc/menu/listMenuVO', params)
  },
  selectUserPermissionList(params) {
    return service.post('/whale-pc/permission/selectUserPermissionList', params, {
      load: false
    })
  },
  leftMenuCornerMarker(params) {
    return service.post('/whale-merge-pc/home/leftMenuCornerMarker', params, {
      load: false
    })
  },
  selfInfo(params) {
    return service.post('/whale-pc/member/selfInfo', params, {
      load: false
    })
  },
  queryDictConfig(params) {
    return service.post('/whale-pc/dictConfig/queryDictConfig', params, {
      load: false
    })
  },
  bubbleGuide(params) {
    return service.post('/whale-pc/bubbleGuide/query', params, {
      load: false
    })
  },
  bubbleGuideAdd(params) {
    return service.post('/whale-pc/bubbleGuide/add', params)
  },
  // 开启账户额度控制
  openAssignAccount(params) {
    return service.post('/ams/quota/assign/openAssignAccount', params)
  },
  // 关闭账户额度控制
  closeAssignAccount(params) {
    return service.post('/ams/quota/assign/closeAssignAccount', params)
  },
  // 查询操作记录
  queryRecordList(params) {
    return service.post('/ams/quota/assign/queryRecordList', params)
  },
  // 查询操作记录接口-关联用户记录
  queryAssignUserOperRecordList(params) {
    return service.post('/ams/quota/assign/queryAssignUserOperRecordList', params)
  },
  
  // 调整账户额度控制
  modifyAssignAccount(params) {
    return service.post('/ams/quota/assign/modifyAssignAccount', params)
  },
  // 查询额度分配账户列表
  queryAssignAccountList(params) {
    return service.post('/ams/quota/assign/queryAssignAccountList', params)
  },
  querySubsidiaryList(params) {
    return service.post('/ams/quota/assign/querySubsidiaryList', params)
  },
  // 校验该用户是否设置智运宝资金密码
  isSettingPassword(params) {
    return service.post('/ams/quota/assign/isSettingPassword', params)
  },
  // 校验该用户智运宝资金密码
  checkPassword(params) {
    return service.post('/ams/quota/assign/checkPassword', params)
  },
  // 校验该用户智运宝资金密码
  newCheckPassword(params) {
    return service.post('/ams/process/checkPassword', params)
  },
  // 支付运费
  freightPayment(params) {
    return service.post('/ams/process/freightPayment', params)
  },
  // 我的运单价格展示权限
  queryMyWaybillPricePermission(params) {
    return service.post('/whale-pc/role/queryMyWaybillPricePermission', params)
  },
  saveOrUpdatePricePermission(params) {
    return service.post('/whale-pc/dataField/saveOrUpdatePricePermission', params)
  },
  // ZCZY-13783 额度管理 ：添加额度
  addAssignQuota(params) {
    return service.post('/ams/quota/assign/addAssignQuota', params)
  },
  // 查询未关联用户接口
  queryAssignAccountNoBindUserList(params) {
    return service.post('/ams/quota/assign/queryAssignAccountNoBindUserList', params)
  },
  // 查询已关联用户接口
  queryAssignAccountBindUserList(params) {
    return service.post('/ams/quota/assign/queryAssignAccountBindUserList', params)
  },
  // 绑定未关联用户接口
  bindAssignUserBatch(params) {
    return service.post('/ams/quota/assign/bindAssignUserBatch', params)
  },
  // 取消绑定已关联用户接口
  unBindAssignUserBatch(params) {
    return service.post('/ams/quota/assign/unBindAssignUserBatch', params)
  },
  // FBIS-469-账本专款专用额度优化--未开启状态增加关闭按钮
  closeAssignAccountToPreOpenStatus(params) {
    return service.post('/ams/quota/assign/closeAssignAccountToPreOpenStatus', params)
  },
  // WLHY-1391 货主新pc首页增加搜索功能和收藏功能---模糊搜索货主菜单
  searchMenu(params) {
    return service.post('/whale-pc/menu/searchMenu', params)
  },
  // WLHY-1391 货主新pc首页增加搜索功能和收藏功能---收藏列表
  collectionList(params) {
    return service.post('/whale-pc/menu/collectionList', params)
  },
  // WLHY-1391 货主新pc首页增加搜索功能和收藏功能---收藏/取消收藏菜单
  collectMenu(params) {
    return service.post('/whale-pc/menu/collectMenu', params)
  },
}